module.exports = __webpack_public_path__ + "img/slide2-992.430cb894.png";